import { IPriceTile } from "../../interfaces/api";
import { useMemo } from "react";

const PriceTile = ({ data }: { data: IPriceTile }) => {
  const valueArray = useMemo(() => {
    if (typeof data.value === "number" && !Number.isNaN(Number(data.value))) {
      return [`$${data.value.toFixed(2)}`];
    }

    if (typeof data.value === "string") {
      return data.value
        .replace(/\\*\\n/g, "\n")
        .replace(/\\/g, "")
        .split("\n")
        .map((str) => str.replace(/^\(+/g, "").replace(/\)+$/g, ""));
    }

    return null;
  }, [data.value]);

  const renderValue = () => {
    if (valueArray !== null) {
      return (
        <h3 className="color-secondary" style={{ paddingBottom: "13px" }}>
          {valueArray[0]}
        </h3>
      );
    }
    return null;
  };

  return (
    <div className="cell small-6 medium-3 text-center">
      {renderValue()}
      <div
        className="larger-text"
        dangerouslySetInnerHTML={{
          __html:
            Array.isArray(valueArray) && valueArray.length > 1
              ? [data.label, ...valueArray?.slice(1)].join("<br />")
              : data.label,
        }}
      ></div>
      {data.desc}
    </div>
  );
};

export default PriceTile;
